/* Both product columns share one boundary; tall content scrolls with the page. */
(() => {
  const setup = section => {
    const row = section.querySelector('.product--thumbnail_slider');
    if (!row || row.dataset.scrollReady) return;
    const pairs = [
      [row.querySelector('.product__media-wrapper'), row.querySelector('.canvoil-media-column')],
      [row.querySelector('.product__info-wrapper'), row.querySelector('product-info')]
    ];
    if (pairs.some(pair => pair.some(element => !element))) return;
    row.dataset.scrollReady = 'true';
    const query = matchMedia('(min-width: 990px)');
    const originals = new Map([row, ...pairs.flat()].map(el => [el, el.getAttribute('style')]));
    const columns = pairs.map(([outer, inner]) => ({outer, inner, top: 64, lower: 64}));
    let previous = scrollY, upper = 64, frame = null;
    const measure = () => {
      if (!query.matches) return;
      const menu = document.querySelector('.canvoil-menu-sticky .header__inline-menu');
      upper = (menu?.getBoundingClientRect().height || 48) + 16;
      columns.forEach(column => {
        column.lower = Math.min(upper, innerHeight - column.inner.offsetHeight - 16);
        column.top = Math.max(column.lower, Math.min(upper, column.top));
        column.inner.style.top = `${column.top}px`;
      });
    };
    const scroll = () => {
      if (frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        const delta = previous - scrollY;
        previous = scrollY;
        columns.forEach(column => {
          column.top = Math.max(column.lower, Math.min(upper, column.top + delta));
          column.inner.style.top = `${column.top}px`;
        });
      });
    };
    const observer = new ResizeObserver(measure);
    const restore = () => originals.forEach((style, element) => {
      if (style === null) element.removeAttribute('style');
      else element.setAttribute('style', style);
    });
    const toggle = () => {
      window.removeEventListener('scroll', scroll);
      observer.disconnect();
      cancelAnimationFrame(frame); frame = null;
      if (!query.matches) { restore(); return; }
      row.style.alignItems = 'stretch';
      columns.forEach(column => {
        Object.assign(column.outer.style, {position:'relative', top:'0', alignSelf:'stretch', paddingBottom:'0'});
        Object.assign(column.inner.style, {display:'flow-root', position:'sticky'});
        column.top = upper;
        observer.observe(column.inner);
      });
      previous = scrollY;
      measure();
      window.addEventListener('scroll', scroll, {passive:true});
    };
    query.addEventListener('change', toggle);
    window.addEventListener('resize', measure);
    toggle();
    const owner = section.closest('.shopify-section') || section;
    owner.addEventListener('shopify:section:unload', () => {
      query.removeEventListener('change', toggle); observer.disconnect();
      window.removeEventListener('resize', measure); window.removeEventListener('scroll', scroll);
      cancelAnimationFrame(frame);
    }, {once:true});
  };
  document.querySelectorAll('[id^="MainProduct-"]').forEach(setup);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[id^="MainProduct-"]')) setup(event.target);
    event.target.querySelectorAll('[id^="MainProduct-"]').forEach(setup);
  });
})();
